import { TemplateTag } from '@debbie/common/dist/templates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../utils/errors.js';
import { Button, Modal, Select } from '../../index.js';
const VersionsModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [selectedTag, setSelectedTag] = useState(undefined);
    const addTagMutation = useMutation(async () => {
        if (selectedTag) {
            await templatesAPI.patch(props.templateId, {
                tag: { tag: selectedTag },
            });
        }
    }, {
        onSuccess: () => {
            props.toggleTagModal();
            props.loadTemplate();
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.template);
        },
    });
    return (React.createElement(Modal, { header: lang.templates.addTag, onToggle: props.toggleTagModal },
        React.createElement(Select, { value: selectedTag, onChange: (e) => setSelectedTag(e.target.value) },
            React.createElement("option", { value: undefined },
                "- ",
                lang.templates.selectTag,
                " -"),
            Object.values(TemplateTag).map((tag) => (React.createElement("option", { key: tag, value: tag }, lang.templateTags[tag])))),
        React.createElement(Button, { onClick: () => addTagMutation.mutate(), disabled: !selectedTag, loading: addTagMutation.isLoading }, lang.templates.addTag)));
};
export default VersionsModal;
//# sourceMappingURL=AddTagModal.js.map